import { Routes } from 'common/constants'
import { THome } from 'contexts/app-context/types/app-context/components/home'

interface HomeFeatureFlags {
  shouldPrefetchNotifications: boolean
  shouldPrefetchPersonalData: boolean
  shouldPrefetchPrivacyPolicy: boolean
  shouldPrefetchFaq: boolean
  shouldPrefetchServices: boolean
}

const deriveHomeFeatureFlags = (content?: THome): HomeFeatureFlags => {
  const activeRoutes = new Set(
    content?.menuSection
      .filter((menuItem) => menuItem.isActive)
      .map((menuItem) => menuItem.route) ?? [],
  )

  return {
    shouldPrefetchNotifications: activeRoutes.has(Routes.NOTIFICATIONS_MANAGEMENT),
    shouldPrefetchPersonalData: activeRoutes.has(Routes.YOUR_PERSONAL_DATA),
    shouldPrefetchPrivacyPolicy: activeRoutes.has(Routes.PRIVACY_POLICY),
    shouldPrefetchFaq: activeRoutes.has(Routes.FREQUENT_QUESTIONS) || !!content?.faqCard?.isActive,
    shouldPrefetchServices:
      activeRoutes.has(Routes.MY_SERVICE_REQUESTS) || !!content?.supportCard?.isActive,
  }
}

export type { HomeFeatureFlags }
export { deriveHomeFeatureFlags }
